import { render } from "./TableroControlGarantias.vue?vue&type=template&id=12d4b75d"
import script from "./TableroControlGarantias.vue?vue&type=script&lang=js"
export * from "./TableroControlGarantias.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__